import i18n from "i18n";

// Messaggio di validazione tradotto: Yup lo richiama a ogni validazione,
// quindi segue la lingua corrente.
export const msg = (key) => () => i18n.t(`common:validation.${key}`);
